import { createActions, createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  setError: ["payload"],
  clearError: null,
});

export const AuthTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  code: undefined,
  menuName: null,
  errorMessage: null,
});

export const setError = (state, { payload }) => {
  const { code, menuName, errorMessage } = payload;
  return state.merge({ code, menuName, errorMessage });
};

export const clearError = (state) =>
  state.merge({ code: undefined, menuName: null, errorMessage: null });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_ERROR]: setError,
  [Types.CLEAR_ERROR]: clearError,
});
